import type { PlanoSeguro } from "@/hooks/usePlanos";

export function getPlanoNome(
  planoId: string | number | null | undefined,
  planos?: PlanoSeguro[] | null
): string {
  if (planoId == null || planoId === "") return "-";

  const id = String(planoId);
  const plano = planos?.find((p) => String(p.id) === id);
  if (plano) return plano.nome;

  switch (id) {
    case "basico":
      return "Básico";
    case "elevo":
      return "Elevo";
    case "renovacao-elevo":
      return "Renovação Elevo";
    case "personalizado":
      return "Personalizado";
    default:
      return id;
  }
}

export function getPlanoColor(
  planoId: string | number | null | undefined,
  planos?: PlanoSeguro[] | null
): string {
  if (planoId == null || planoId === "") return "bg-gray-100 text-gray-800";

  const id = String(planoId);
  const plano = planos?.find((p) => String(p.id) === id);
  if (!plano) {
    switch (id) {
      case "elevo":
        return "bg-blue-100 text-blue-800";
      case "renovacao-elevo":
        return "bg-purple-100 text-purple-800";
      case "personalizado":
        return "bg-orange-100 text-orange-800";
      case "basico":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  }

  const nomePlano = plano.nome.toLowerCase();
  if (nomePlano.includes("elevo")) return "bg-blue-100 text-blue-800";
  if (nomePlano.includes("renovação") || nomePlano.includes("renovacao"))
    return "bg-purple-100 text-purple-800";
  if (nomePlano.includes("personalizado")) return "bg-orange-100 text-orange-800";
  if (nomePlano.includes("básico") || nomePlano.includes("basico"))
    return "bg-green-100 text-green-800";

  return "bg-gray-100 text-gray-800";
}
